import { getCustomComponents } from '../pluginComponentApi';

export const getCustomComponentTraits = async (projectId, version, labelColName) => {
  const customComponent = await getCustomComponents(projectId, version);
  let options = [];
  options.push({ value: '', name: '- Select Custom Component -' });
  if (customComponent && customComponent.data) {
    customComponent.data.forEach((item) => {
      options.push({ value: item.uuid, name: item.name });
    });
  }

  return {
    type: 'select',
    label: labelColName,
    name: 'customComponentUuid',
    changeProp: 1,
    options,
  };
};
